import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AdminLayout from "../layouts/AdminLayout";
import { getAircrafts, addAircraft, updateAircraft } from "../api/aircraftApi";
import { showError } from "../utils/alert";

const initialForm = {
  model: "",
  manufacturer: "",
  aircraft_type: "",
  capacity: "",
  range_km: "",
};

export default function AircraftForm() {
  const { id } = useParams();
  const navigate = useNavigate();
  const isEdit = Boolean(id);
  const [form, setForm] = useState(initialForm);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isEdit) {
      loadAircraft();
    }
  }, [id]);

  const loadAircraft = async () => {
    try {
      const res = await getAircrafts({ page: 1, per_page: 1000 });
      const aircraft = res.data.items.find((a) => a.id === parseInt(id));
      if (aircraft) {
        setForm({
          model: aircraft.model || "",
          manufacturer: aircraft.manufacturer || "",
          aircraft_type: aircraft.aircraft_type || "",
          capacity: aircraft.capacity != null ? String(aircraft.capacity) : "",
          range_km: aircraft.range_km != null ? String(aircraft.range_km) : "",
        });
      } else {
        showError("Aircraft not found");
        navigate("/aircrafts");
      }
    } catch (err) {
      showError("Failed to load aircraft");
      navigate("/aircrafts");
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.model.trim()) {
      return showError("Model is required");
    }

    setLoading(true);
    try {
      const payload = {
        ...form,
        capacity: form.capacity ? Number(form.capacity) : null,
        range_km: form.range_km ? Number(form.range_km) : null,
      };
      if (isEdit) {
        await updateAircraft(id, payload);
      } else {
        await addAircraft(payload);
      }
      navigate("/aircrafts");
    } catch (err) {
      showError(isEdit ? "Failed to update aircraft" : "Failed to add aircraft");
    } finally {
      setLoading(false);
    }
  };

  return (
    <AdminLayout title={isEdit ? "Edit Aircraft" : "Add Aircraft"}>
      <div className="card shadow-sm">
        <div className="card-body">
          <h5 className="card-title mb-3">
            {isEdit ? "Edit Aircraft" : "Add New Aircraft"}
          </h5>
          <form onSubmit={handleSubmit}>
            <div className="mb-3">
              <label className="form-label">Model *</label>
              <input
                name="model"
                className="form-control"
                value={form.model}
                onChange={handleChange}
                required
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Manufacturer</label>
              <input
                name="manufacturer"
                className="form-control"
                value={form.manufacturer}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Type</label>
              <input
                name="aircraft_type"
                className="form-control"
                value={form.aircraft_type}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Capacity</label>
              <input
                name="capacity"
                type="number"
                className="form-control"
                value={form.capacity}
                onChange={handleChange}
              />
            </div>
            <div className="mb-3">
              <label className="form-label">Range (km)</label>
              <input
                name="range_km"
                type="number"
                className="form-control"
                value={form.range_km}
                onChange={handleChange}
              />
            </div>
            <div className="d-flex gap-2">
              <button
                type="submit"
                className="btn skedq-accent-btn"
                disabled={loading}
              >
                {loading ? "Saving..." : isEdit ? "Update" : "Add"}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary"
                onClick={() => navigate("/aircrafts")}
              >
                Cancel
              </button>
            </div>
          </form>
        </div>
      </div>
    </AdminLayout>
  );
}
